import { render, staticRenderFns } from "./TrainingCenterDetails.vue?vue&type=template&id=21261d3e"
import script from "./TrainingCenterDetails.vue?vue&type=script&lang=js"
export * from "./TrainingCenterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports